import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static targets = ["countdown", "list", "modal"];

  static values = {
    refreshInterval: { type: Number, default: 30 },
    pointingsUrl: String,
    manualUrl: String,
    qrUrl: String,
    qrPointingsUrl: String,
  };

  connect() {
    this.restartCountdown();

    // Écouter l'événement de fermeture de modale
    this.closeModalBinded = this.closeModal.bind(this);
    document.addEventListener('closeModal', this.closeModalBinded);
    document.addEventListener('modal:closed', this.closeModalBinded);
  }

  disconnect() {
    this.stopCountdown();
    document.removeEventListener('closeModal', this.closeModalBinded);
    document.removeEventListener('modal:closed', this.closeModalBinded);
  }

  refresh() {
    this.restartCountdown(false);
    this.fetchPointings();
  }

  manualEntry() {
    this.openModal(this.manualUrlValue);
  }

  scanQr() {
    this.openModal(this.qrUrlValue);
  }

  closeModal() {
    // Si on a un target modal (le conteneur Alpine), on l'utilise directement
    if (this.hasModalTarget && window.Alpine) {
      const data = window.Alpine.$data(this.modalTarget);
      if (data && typeof data.open !== 'undefined') {
        data.open = false;
        return;
      }
    }

    // Fallback : chercher le bouton de fermeture dans le DOM (la modale est peut-être téléportée)
    // On utilise un sélecteur plus robuste pour Alpine @click
    const closeButtons = document.querySelectorAll('button[x-on\\:click*="open ="], button[\\@click*="open ="]');
    for (const btn of closeButtons) {
      if (btn.offsetParent !== null) { // Vérifier si le bouton est visible
        btn.click();
        return;
      }
    }

    // Dernier recours : chercher n'importe quel élément avec l'état open à true
    const openModals = document.querySelectorAll('[x-data*="open: true"], [x-data*="open : true"]');
    openModals.forEach(el => {
      if (window.Alpine) {
        window.Alpine.$data(el).open = false;
      }
    });
  }

  restartCountdown(resetRemaining = true) {
    this.stopCountdown();
    if (resetRemaining) {
      this.remaining = this.refreshIntervalValue;
      this.updateCountdown();
    }
    this.timer = setInterval(() => {
      this.remaining -= 1;
      if (this.remaining <= 0) {
        this.fetchPointings();
      } else {
        this.updateCountdown();
      }
    }, 1000);
  }

  stopCountdown() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  updateCountdown() {
    if (this.hasCountdownTarget) {
      this.countdownTarget.textContent = this.remaining > 0
        ? this.t('js.rh.teacher_attendances.pointing.countdown.short', { seconds: this.remaining })
        : this.t('js.rh.teacher_attendances.pointing.countdown.waiting');
    }
  }

  fetchPointings() {
    const url = this.pointingsUrlValue || window.location.href;

    // Ne pas faire de requête si l'URL n'est pas valide
    if (!url) {
      console.warn('Invalid pointings URL, stopping auto-refresh');
      this.stopCountdown();
      return;
    }

    fetch(url, {
      headers: {
        Accept: "text/vnd.turbo-stream.html",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        return response.text();
      })
      .then((html) => {
        if (html && html.trim().length > 0) {
          Turbo.renderStreamMessage(html);
        }
        this.remaining = this.refreshIntervalValue;
        // this.updateCountdown();
        // this.restartCountdown(false);
      })
      .catch((error) => {
        console.error('Error fetching pointings:', error);
        // En cas d'erreur, arrêter le countdown pour éviter la boucle infinie
        this.stopCountdown();
        this.remaining = this.refreshIntervalValue;
        this.updateCountdown();
      });
  }

  t(key, options = {}) {
    if (typeof window !== "undefined" && typeof window.t === "function") {
      return window.t(key, options);
    }
    return key;
  }
}
